import { withProductListProps } from 'viewModel/content/productList/withProductListProps';
import ProductList from 'components/Content/ProductList/ProductList';

export default withProductListProps(ProductList);
